import axios, { AxiosRequestConfig } from 'axios';
import HdlToast from '@/utils/toast'

let baseUrl = 'https://hdl-activity.haidilao.com' //生成
// const BASE_URL = process.env.NODE_ENV === 'production' ? baseUrl+"/api" : '/api'//本地代理
if(window.location.href.indexOf('superapp-public.hdltest.com') > -1) {
  baseUrl = 'https://superapp-public.hdltest.com'
}
const BASE_URL = process.env.NODE_ENV === 'production' ? baseUrl+"" : ''


function _axios(method: AxiosRequestConfig["method"], url: string, data?: any, isLoading = false, isFail = false) {
  console.log(isLoading)
  let userInfo: any = sessionStorage.getItem('userInfo');
  if (userInfo) {
    userInfo = JSON.parse(userInfo);
    data['customerId'] = userInfo.id ? userInfo.id : ''
  }
  // data['companyId'] = 2;
  return new Promise((resolve, reject) => {
    axios({
      method: method,
      url: BASE_URL + url,
      data: data,
      headers: {
        'Content-Type': 'application/json',
        'ReqType': 'APPH5'
      }
    }).then((res) => {
      const val = res.data ? res.data : res;
      if (isFail) {
        resolve(val)
      } else {
        if (val.success === true) {
          resolve(val.data)
        } else {
          HdlToast.info(val.msg?val.msg:'系统错误')
          console.log('后期错误处理')
          reject(res)
        }
      }
    }).catch(err => {
      HdlToast.info(err.msg?err.msg:'系统错误')
      reject(err)
    });
  })
}


function _post(url: string, data: object, isLoading = false, isFail = false) {
  return new Promise((resolve, reject) => {
    _axios('post', url, data, isLoading, isFail).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}


function _get(url: string, data?: object, isLoading = false, isFail = false) {
  return new Promise((resolve, reject) => {
    _axios('get', url, data, isLoading, isFail).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}
//eslint-disable-next-line
export default {
  get: _get,
  post: _post
}
